/* src/app/components/summarize/summarize/summarize.component.scss */
.summarization-page {
  --primary: #253b80;
  --primary-dark: #1d2f68;
  --primary-light: #eef2ff;
  --success: #16a34a;
  --success-light: #ecfdf3;
  --text: #172033;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --border: #e5e7eb;
  --border-light: #eef0f4;
  --background: #f5f7fb;
  --white: #ffffff;
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 20px;
  background: var(--background);
}
.summarization-layout {
  position: relative;
  width: 100%;
  max-width: 1600px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 18px;
  margin: 0 auto;
  transition: grid-template-columns 0.3s ease, gap 0.3s ease;
}
.summarization-layout.left-collapsed {
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 14px;
}
.summary-left-panel {
  min-width: 0;
}
.left-panel-card {
  position: sticky;
  top: 15px;
  min-height: 500px;
  overflow: hidden;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 15px;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.04);
  transition: min-height 0.3s ease, border-radius 0.3s ease;
}
.panel-header {
  position: relative;
  min-height: 82px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px;
  border-bottom: 1px solid var(--border-light);
}
.panel-header-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  border-radius: 11px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 17px;
}
.panel-header-content {
  min-width: 0;
  flex: 1;
}
.panel-header h4 {
  margin: 0 0 4px;
  color: var(--text);
  font-size: 15px;
  font-weight: 700;
}
.panel-header p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 11px;
  line-height: 1.5;
}
.panel-collapse-button {
  position: absolute;
  top: 50%;
  right: 12px;
  z-index: 10;
  width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #d8ddea;
  border-radius: 50%;
  background: #fff;
  color: var(--text-secondary);
  font-size: 9px;
  cursor: pointer;
  transform: translateY(-50%);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.1);
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.panel-collapse-button:hover {
  border-color: var(--primary);
  background: var(--primary);
  color: #fff;
  transform: translateY(-50%) scale(1.05);
}
.panel-collapse-button:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}
.summary-input-area {
  padding: 22px;
}
.input-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}
.title-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f8fafc;
  color: var(--text-secondary);
  font-size: 13px;
}
.input-section-title strong {
  display: block;
  margin-bottom: 2px;
  color: var(--text);
  font-size: 12px;
  font-weight: 650;
}
.input-section-title span {
  display: block;
  color: var(--text-muted);
  font-size: 10px;
}
.summarize-input-wrapper {
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 11px;
  background: #fbfcfe;
}
.secure-card {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 22px;
  padding: 12px;
  border: 1px solid #dff1e5;
  border-radius: 10px;
  background: #f5fcf7;
}
.secure-icon {
  width: 31px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 31px;
  border-radius: 8px;
  background: #dcfce7;
  color: var(--success);
  font-size: 12px;
}
.secure-content {
  min-width: 0;
  flex: 1;
}
.secure-content strong {
  display: block;
  margin-bottom: 2px;
  color: #166534;
  font-size: 10px;
  font-weight: 700;
}
.secure-content span {
  display: block;
  color: #4d7c5c;
  font-size: 9px;
  line-height: 1.4;
}
.secure-check {
  color: var(--success);
  font-size: 11px;
}
.left-panel-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 18px;
  padding: 12px 22px;
  border-top: 1px solid var(--border-light);
  background: #fbfcfe;
}
.left-panel-footer div {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 7px;
  border-radius: 6px;
  color: var(--text-muted);
  font-size: 9px;
  font-weight: 600;
}
.left-collapsed-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 22px 5px;
}
.collapsed-icon {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 13px;
}
.left-collapsed-content > span {
  writing-mode: vertical-rl;
  color: var(--text);
  font-size: 10px;
  font-weight: 700;
}
.left-collapsed-content small {
  writing-mode: vertical-rl;
  color: var(--text-muted);
  font-size: 8px;
}
.summary-right-panel {
  min-width: 0;
}
.results-card {
  min-height: 500px;
  overflow: hidden;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 15px;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.04);
}
.results-header {
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--border);
}
.results-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.results-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  border-radius: 10px;
  background: #f3f0ff;
  color: var(--primary);
  font-size: 16px;
}
.results-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 3px;
}
.results-title-row h4 {
  margin: 0;
  color: var(--text);
  font-size: 15px;
  font-weight: 700;
}
.result-badge {
  min-width: 22px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 6px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 10px;
  font-weight: 700;
}
.results-header-left p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 10px;
}
.results-actions {
  display: flex;
  align-items: center;
  gap: 5px;
}
.action-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  border: 1px solid var(--border);
  border-radius: 7px;
  background: #fff;
  color: var(--text-secondary);
  font-family: inherit;
  font-size: 9px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.action-button:hover {
  border-color: #cfd4ff;
  background: var(--primary-light);
  color: var(--primary);
}
.summary-list {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 16px;
}
.summary-item {
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 11px;
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.summary-item:hover {
  border-color: #d9dded;
}
.summary-item.expanded {
  border-color: #cdd3ff;
  box-shadow: 0 4px 14px rgba(37, 59, 128, 0.07);
}
.summary-item-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 14px 15px;
  border: 0;
  background: transparent;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
}
.summary-item-header:hover {
  background: #fafbff;
}
.summary-item-header:focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: -2px;
}
.summary-item-left {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}
.summary-index {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 35px;
  border-radius: 9px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 12px;
  font-weight: 700;
}
.summary-item-info {
  min-width: 0;
}
.summary-label {
  display: block;
  margin-bottom: 2px;
  color: var(--primary);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.summary-item-info strong {
  display: block;
  margin-bottom: 5px;
  overflow: hidden;
  color: var(--text);
  font-size: 12px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.summary-status {
  display: flex;
  align-items: center;
  gap: 10px;
}
.summary-status span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--text-muted);
  font-size: 8px;
}
.summary-status span:first-child {
  color: var(--success);
}
.summary-item-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}
.view-text {
  color: var(--text-muted);
  font-size: 9px;
  font-weight: 600;
}
.toggle-icon {
  width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 7px;
  color: var(--text-secondary);
  font-size: 9px;
  transition: all 0.2s ease;
}
.summary-item.expanded .toggle-icon {
  border-color: #d8dcff;
  background: var(--primary-light);
  color: var(--primary);
}
.summary-item-body {
  padding: 18px;
  border-top: 1px solid var(--border);
  background: #fafbfe;
  animation: summaryOpen 0.2s ease;
}
@keyframes summaryOpen {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.summary-body-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
}
.summary-body-header > div:first-child > span {
  display: block;
  margin-bottom: 3px;
  color: var(--primary);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
}
.summary-body-header h5 {
  margin: 0;
  color: var(--text);
  font-size: 12px;
  font-weight: 650;
}
.ready-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border: 1px solid #d9efdf;
  border-radius: 20px;
  background: #f3fbf5;
  color: #15803d;
  font-size: 8px;
  font-weight: 600;
}
.ready-status span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #22c55e;
}
.empty-results {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 25px;
  text-align: center;
}
.empty-icon-wrapper {
  position: relative;
  width: 82px;
  height: 75px;
  margin-bottom: 18px;
}
.empty-icon {
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 6px auto;
  border-radius: 17px;
  background: var(--primary-light);
  color: var(--primary);
  font-size: 24px;
}
.empty-spark {
  position: absolute;
  width: 21px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);
  font-size: 8px;
}
.spark-one {
  top: 0;
  right: 1px;
  color: var(--primary);
}
.spark-two {
  bottom: 0;
  left: 1px;
  color: #16a34a;
}
.empty-results h4 {
  margin: 0 0 7px;
  color: var(--text);
  font-size: 16px;
  font-weight: 700;
}
.empty-results p {
  max-width: 380px;
  margin: 0 0 17px;
  color: var(--text-secondary);
  font-size: 11px;
  line-height: 1.7;
}
.empty-action {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 11px;
  border-radius: 8px;
  background: #f8fafc;
  color: var(--text-secondary);
  font-size: 10px;
  font-weight: 600;
}
.empty-action i {
  color: var(--primary);
}
.pagination-area {
  padding: 0 16px 16px;
}
@media (max-width: 900px) {
  .summarization-layout,
  .summarization-layout.left-collapsed {
    grid-template-columns: minmax(0, 1fr);
    gap: 15px;
  }
  .left-panel-card {
    position: relative;
    top: auto;
    min-height: auto;
  }
  .summary-left-panel {
    width: 100%;
  }
  .panel-collapse-button {
    right: 12px;
  }
  .left-collapsed-content {
    display: none;
  }
}
@media (max-width: 576px) {
  .summarization-page {
    padding: 10px;
  }
  .panel-header {
    min-height: 70px;
    padding: 14px;
  }
  .panel-header-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }
  .summary-input-area {
    padding: 15px;
  }
  .secure-card {
    margin: 0 15px;
  }
  .left-panel-footer {
    padding: 10px 15px;
  }
  .results-header {
    align-items: flex-start;
    flex-direction: column;
    padding: 15px;
  }
  .results-actions {
    width: 100%;
  }
  .action-button {
    flex: 1;
    justify-content: center;
  }
  .summary-list {
    padding: 10px;
  }
  .view-text {
    display: none;
  }
  .summary-item-body {
    padding: 13px;
  }
  .summary-body-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (prefers-reduced-motion: reduce) {
  .summarization-layout,
  .left-panel-card,
  .panel-collapse-button,
  .summary-item,
  .toggle-icon,
  .summary-item-body,
  .action-button {
    transition: none;
    animation: none;
  }
}
/*# sourceMappingURL=summarize.component.css.map */
